// extracted by mini-css-extract-plugin
module.exports = {"input":"style_input__302G5","placeholder":"style_placeholder__3tj8w","checkbox-input":"style_checkbox-input__2dXmQ","icon":"style_icon__24FaX"};